"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getIndexBefore_1 = __importDefault(require("../query/getIndexBefore"));

var constants_1 = require("../constants");

function backspaceToPrevWord(editorState, start, end) {
  var newEditorState = editorState;
  var prevChar = editorState.list.value[start];

  if (prevChar.type == null) {
    var spaceBefore = false;
    var isBlockStart = false;
    var prevWordEnd = getIndexBefore_1.default(editorState.list.value, start, function (ch) {
      if (ch.type !== 'block-start' && ch.type !== 'block-end') {
        spaceBefore = ch.char === ' ';
      }

      if (ch.type === 'block-start') {
        isBlockStart = true;
        return true;
      }

      if (ch.type == null && spaceBefore) {
        return true;
      }

      return false;
    });

    if (prevWordEnd != null) {
      newEditorState = editorState.change({
        type: constants_1.COMMAND.BACKSPACE_PREV_WORD,
        start: isBlockStart ? prevWordEnd : prevWordEnd,
        end: end,
        value: [],
        isBoundary: true
      });
    }
  }

  return newEditorState;
}

exports.default = backspaceToPrevWord;